import React, { useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";

import "./Header.css";

const pageTitles = {
  "/admin": "Dashboard",
  "/admin/dashboard": "Dashboard",
  "/admin/category": "Category",
  "/admin/addCategory": "Add Category",
  "/admin/products": "Products",
  "/admin/addProducts": "Add Product",
  "/admin/user": "Users",
};

export default function Header({ toggleSidebar }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const title = useMemo(
    () => pageTitles[location.pathname] || "Admin Workspace",
    [location.pathname]
  );

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <header className="admin-header">
      <div className="admin-header-left">
        <button
          type="button"
          className="admin-icon-btn"
          onClick={toggleSidebar}
          aria-label="Toggle sidebar"
        >
          <MenuIcon />
        </button>

        <div>
          <p className="admin-header-eyebrow">Tecniqa Admin</p>
          <h1 className="admin-header-title">{title}</h1>
        </div>
      </div>

      <div className="admin-header-right">
        <div className="admin-status-pill">
          <span />
          Store Online
        </div>

        <div className="admin-profile-wrap">
          <button
            type="button"
            className="admin-profile-btn"
            onClick={() => setOpen((value) => !value)}
            aria-expanded={open}
          >
            <AccountCircleIcon className="admin-profile-icon" />
            <span>Admin</span>
            <KeyboardArrowDownIcon className={open ? "rotate" : ""} />
          </button>

          {open && (
            <div className="admin-dropdown">
              <button type="button" className="admin-dropdown-item" onClick={handleLogout}>
                <LogoutIcon />
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
